import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const DataArticleIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 30,
  height = 30,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
        transform="translate(-443.000000, -46.000000)"
      >
        <g transform="translate(443.000000, 46.000000)">
          <path
            d="M-0.0001,15 C-0.0001,23.284 6.7159,30 14.9999,30 C23.2839,30 29.9999,23.284 29.9999,15 C29.9999,6.716 23.2839,0 14.9999,0 C6.7159,0 -0.0001,6.716 -0.0001,15"
            fill="#EB9500"
          />
          <polyline
            points="5.9999 9.6689 5.9999 22.2579 23.5649 22.2579"
            stroke="#FFFFFF"
            className={styles.whiteStroke}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polygon
            fill="#ffffff"
            className={styles.white}
            points="7.2147 9.832 4.7847 9.832 5.9997 8.617"
          />
          <polygon
            fill="#ffffff"
            className={styles.white}
            points="23.2728 23.2548 24.9998 22.2588 23.2728 21.2608"
          />
          <path
            d="M10.5267,18.5048 C10.5267,19.0578 10.0787,19.5048 9.5267,19.5048 C8.9747,19.5048 8.5267,19.0578 8.5267,18.5048 C8.5267,17.9518 8.9747,17.5048 9.5267,17.5048 C10.0787,17.5048 10.5267,17.9518 10.5267,18.5048"
            fill="#ffffff"
            className={styles.white}
          />
          <path
            d="M12.2914,14.5048 C12.2914,15.0578 11.8434,15.5048 11.2914,15.5048 C10.7394,15.5048 10.2914,15.0578 10.2914,14.5048 C10.2914,13.9518 10.7394,13.5048 11.2914,13.5048 C11.8434,13.5048 12.2914,13.9518 12.2914,14.5048"
            fill="#ffffff"
            className={styles.white}
          />
          <path
            d="M16.703,15.5048 C16.703,16.0578 16.256,16.5048 15.703,16.5048 C15.151,16.5048 14.703,16.0578 14.703,15.5048 C14.703,14.9518 15.151,14.5048 15.703,14.5048 C16.256,14.5048 16.703,14.9518 16.703,15.5048"
            fill="#ffffff"
            className={styles.white}
          />
          <path
            d="M19.3505,11.5048 C19.3505,12.0578 18.9025,12.5048 18.3505,12.5048 C17.7985,12.5048 17.3505,12.0578 17.3505,11.5048 C17.3505,10.9518 17.7985,10.5048 18.3505,10.5048 C18.9025,10.5048 19.3505,10.9518 19.3505,11.5048"
            fill="#ffffff"
            className={styles.white}
          />
          <path
            d="M23.7621,9.5048 C23.7621,10.0578 23.3141,10.5048 22.7621,10.5048 C22.2101,10.5048 21.7621,10.0578 21.7621,9.5048 C21.7621,8.9518 22.2101,8.5048 22.7621,8.5048 C23.3141,8.5048 23.7621,8.9518 23.7621,9.5048"
            fill="#ffffff"
            className={styles.white}
          />
          <polyline
            points="9.5267 18.5048 11.2917 14.5048 15.7027 15.5048 18.3507 11.5048 22.7617 9.5048"
            stroke="#FFFFFF"
            className={styles.whiteStroke}
            strokeWidth="0.5"
          />
        </g>
      </g>
    </Icon>
  )
}
